import { Autocomplete, Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, InputLabel, ListItem, MenuItem, Select } from "@mui/material"
import CustomInput from "../../components/inputs/CustomInput"
import { GENDER, REGIONS_TYPE, USER_ROLES } from "../../utils/constants"
import { findObjectKeyByValue } from "../../utils/helper"
import { DatePicker, DesktopDatePicker, MobileDatePicker } from "@mui/x-date-pickers"
import moment from "moment"
import CreatableRegionComponent from "../../components/custom/CreateableRegionComponent"
import FileInput from "../../components/inputs/FileInput"
import { CAMP_STATUS, STANDAERED } from "../../utils/beneficiary.constant"
import CreatableDropDownComponent from "../../components/custom/CreateableDropodown"
import CampController from "../camp/CreateController"
import { useSelector } from "react-redux"
import MODULES from "../../utils/module.constant"
import { getCampApi } from "../../apis/camp.api"
import CreateController from "../user/CreateController"
import Grid2 from "@mui/material/Unstable_Grid2"
import AsyncDropDown from "../../components/inputs/AsyncDropDown"
import { getCityApi, getCountryApi, getStateApi } from "../../apis/CountryStateCity.api"

const PersonalDetailsFields = ({ show, fields, setFields, loading }) => {
    const { user } = useSelector(state => state)
    console.log("fields", fields)

    const ahmedabadTalukaList = [
        { id: 1, label: "Daskroi" },
        { id: 2, label: "Sanand" },
        { id: 3, label: "Dholka" },
        { id: 4, label: "Viramgam" },
        { id: 5, label: "Detroj-Rampura" },
        { id: 6, label: "Bavla" },
        { id: 7, label: "Mandal" },
        { id: 8, label: "Barwala" },
        { id: 9, label: "Ahmedabad City" },
    ];



    return <>
        <Box sx={{ width: "100%", display: show ? "block" : "none" }} p={2}>

            <Grid container columnSpacing={2} >
                {/* <Grid item sm={12} xs={12}>
                    <CreatableDropDownComponent
                        onlyDropDown={!user.data?.modules?.includes?.(MODULES.CAMPS)}
                        createComponent={<CampController />}
                        modalKey='create-camp'
                        disabled={loading}
                        value={typeof fields.camp == "object" ? fields.camp : null}
                        label={"Select Camp*"}
                        getApi={async (params) => await getCampApi({ ...params, status: CAMP_STATUS.OPEN, allStatus: true, allDetails: true })}
                        onChange={async (changedVal) => {

                            setFields({
                                ...fields,
                                camp: (changedVal ? changedVal : null),
                                // country: (changedVal ? changedVal.country : null),
                                // state: (changedVal ? changedVal.state : null),
                                // district: (changedVal ? changedVal.district : null),
                                // taluka: (changedVal ? changedVal.taluka : null),
                            })
                        }}
                    />

                </Grid> */}

                {/* <Grid item sm={6} xs={12}>
                    <CreatableDropDownComponent
                        onlyDropDown={!user.data?.modules?.includes?.(MODULES.TEACHER)}
                        createComponent={<CreateController role={USER_ROLES.TEACHER} />}
                        modalKey='users'
                        disabled={loading}
                        value={typeof fields.teacher == "object" ? fields.teacher : null}
                        label={"Select Teacher"}
                        getApi={async (params) => await getTeachersApi(params)}
                        onChange={async (changedVal) => {

                            setFields({ ...fields, teacher: (changedVal ? changedVal : null) })
                        }}
                    />
                </Grid> */}


                <Grid item sm={6} xs={12}>
                    <CustomInput
                        autoFocus={true}
                        disabled={loading}
                        value={fields.first_name}
                        onChange={(e) => setFields({ ...fields, err: '', first_name: e.target.value })}
                        type="text"
                        label={"First Name*"}

                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.last_name}
                        onChange={(e) => setFields({ ...fields, err: '', last_name: e.target.value })}
                        type="text"
                        label={"Last Name"}

                    />
                </Grid>

                <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.phone}
                        onChange={(e) => setFields({ ...fields, err: '', phone: e.target.value, family_contact: e.target.value })}
                        type="number"
                        label={"Phone No*"}

                    />
                </Grid>
                <Grid item sm={6} xs={8}>
                    <CustomInput

                        disabled={loading}
                        value={fields.email}
                        onChange={(e) => setFields({ ...fields, err: '', email: e.target.value })}
                        type="email"
                        label={"Email"}

                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <Autocomplete
                        value={findObjectKeyByValue(fields.gender, GENDER)}
                        disableClearable
                        onChange={(val, newVal) => {
                            setFields({ ...fields, err: '', gender: newVal._id })
                        }}
                        options={Object.keys(GENDER).map((key) => ({ label: key, _id: GENDER[key] }))}


                        renderInput={(params) => <CustomInput placeholder="Select Gender*" {...params} />}
                    />

                </Grid>
                <Grid item sm={6} xs={12}>

                    <DatePicker

                        views={['month', 'year', 'day']}
                        value={moment(fields.dob)}
                        inputFormat="DD/MM/YYYY"
                        disableFuture
                        onChange={(val) => {
                            setFields({ ...fields, err: '', dob: val?.toISOString() })
                        }}
                        label="Select DOB*"
                        renderInput={(params) => <CustomInput placeholder="Select DOB*"  {...params} />}
                    />


                </Grid>
                {/* <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.school}
                        onChange={(e) => setFields({ ...fields, err: '', school: e.target.value })}
                        type="text"
                        label={"School"}

                    />
                </Grid> */}

                <Grid item sm={4} xs={12}>
                    <FormControl fullWidth={true} margin="dense" >
                        <CustomInput


                            disabled={loading}
                            value={fields.organization}
                            onChange={(e) => setFields({ ...fields, err: '', organization: e.target.value })}
                            type="text"
                            label={"Organization"}

                        />
                    </FormControl>
                </Grid>
                <Grid item sm={4} xs={12}>
                    <FormControl fullWidth={true} margin="dense" >
                        <CustomInput


                            disabled={loading}
                            value={fields.department}
                            onChange={(e) => setFields({ ...fields, err: '', department: e.target.value })}
                            type="text"
                            label={"Department"}

                        />
                    </FormControl>
                </Grid>

                <Grid item sm={4} xs={12}>
                    <FormControl fullWidth={true} margin="dense" >
                        <CustomInput


                            disabled={loading}
                            value={fields.designation}
                            onChange={(e) => setFields({ ...fields, err: '', designation: e.target.value })}
                            type="text"
                            label={"Designation"}

                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <CustomInput
                        multiline
                        rows={2}

                        disabled={loading}
                        value={fields.address_line}
                        onChange={(e) => setFields({ ...fields, err: '', address_line: e.target.value })}
                        type="text"
                        label={"Address (Street/ Village Name)*"}

                    />
                </Grid>

                <Grid item sm={3} xs={12}>
                    <FormControl fullWidth={true} margin="dense" >
                        <CustomInput


                            disabled={loading}
                            value={fields.PIN}
                            onChange={(e) => setFields({ ...fields, err: '', PIN: e.target.value })}
                            type="text"
                            label={"PIN"}

                        />
                    </FormControl>
                </Grid>
                <Grid mt={3} item sm={3} xs={12}>
                    <AsyncDropDown
                        // key={fields.district}
                        // disabled={!}
                        Value={fields?.country ? { _id: 1, name: fields?.country } : null}
                        lazyFun={async (para) => await getCountryApi({ ...para, allStatus: true, isName: true })}
                        OptionComponent={({ option, ...rest }) => {
                            return <ListItem {...rest}>{option.name}</ListItem >
                        }}
                        onChange={async (changedVal) => {
                            setFields((prev) => ({
                                ...prev,
                                // state: changedVal?._id || "",
                                country: changedVal?.name || "",
                                taluka: "",
                                state: "",
                                district: "",
                                // cityName: "",
                            }));
                        }}
                        titleKey={'name'}
                        valueKey={"_id"}
                        InputComponent={(params) => <CustomInput placeholder={"Select Country"} label={"Country"} {...params} margin="none" />}
                    />

                </Grid>
                <Grid mt={3} item sm={3} xs={12}>
                    <AsyncDropDown
                        key={fields.state}
                        // disabled={!}
                        Value={fields?.state ? { _id: 1, name: fields?.state } : null}
                        lazyFun={async (para) => await getStateApi({ ...para, allStatus: true, country: fields?.country, isName: true })}
                        OptionComponent={({ option, ...rest }) => {
                            return <ListItem {...rest}>{option.name}</ListItem >
                        }}
                        onChange={async (changedVal) => {
                            setFields((prev) => ({
                                ...prev,
                                // state: changedVal?._id || "",
                                state: changedVal?.name || "",
                                district: "",
                                // cityName: "",
                            }));
                        }}
                        titleKey={'name'}
                        valueKey={"_id"}
                        InputComponent={(params) => <CustomInput placeholder={"Select State"} label={"State"} {...params} margin="none" />}
                    />

                </Grid>
                <Grid mt={3} item sm={3} xs={12}>
                    <AsyncDropDown
                        key={fields.state}
                        disabled={!(fields.state)}
                        Value={fields?.district ? { _id: 3, name: fields?.district } : null}
                        lazyFun={async (para) => await getCityApi({ ...para, allStatus: true, state: fields.state, isName: true })}
                        OptionComponent={({ option, ...rest }) => {
                            return <ListItem {...rest}>{option.name}</ListItem >
                        }}
                        onChange={async (changedVal) => {
                            setFields((prev) => ({
                                ...prev,
                                district: changedVal?.name || "",
                                taluka: "",
                            }));
                        }}
                        titleKey={'name'}
                        valueKey={"_id"}
                        InputComponent={(params) => <CustomInput placeholder={"Select District"} label={"District"} {...params} margin="none" />}
                    />
                </Grid>
                {/* <Grid mt={2} item sm={2} xs={12}>
                    <CustomInput
                        disabled={loading}
                        value={fields.taluka}
                        onChange={(e) =>
                            setFields({ ...fields, err: "", taluka: e.target.value })
                        }
                        type="text"
                        label={"Taluka"}
                    />
                </Grid> */}

                {/* <Grid item xs={12} sm={6}>
                    <CustomInput
                        disabled={loading}
                        value={fields.aadhar}
                        onChange={(e) => setFields({ ...fields, err: '', aadhar: e.target.value })}
                        type="number"
                        label={"Aadhar No."}

                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <CustomInput
                        disabled={loading}
                        value={fields.udise_no}
                        onChange={(e) => setFields({ ...fields, err: '', udise_no: e.target.value })}
                        type="text"
                        label={"UDISE No"}
                    />
                </Grid> */}


                {/* <Grid item xs={12}>
                    <FileInput
                        defaults={fields.udise_file && fields.udise_file != '' ? [fields.udise_file] : undefined}
                        title="Attached Documents(if available)"
                        subTitle="Only .pdf less than 1mb are required."
                        accept=".pdf"
                        onChange={(newUrl) => {
                            setFields({ ...fields, err: '', udise_file: newUrl })
                        }}
                        onDelete={(newList) => { setFields({ ...fields, udise_file: '' }) }}
                    />
                </Grid> */}
                {/* <Grid item xs={12}>
                    <FileInput
                        defaults={fields.aadhar_file && fields.aadhar_file!='' ? [fields.aadhar_file] : undefined}
                        title="Adhdar Card(if available)"
                        subTitle="Only .pdf less than 1mb are required."
                        accept=".pdf"
                        onChange={(newUrl) => {
                            setFields({ ...fields, err: '', aadhar_file: newUrl })
                        }}
                        onDelete={(newList) => { setFields({ ...fields, aadhar_file: '' }) }}
                    />
                </Grid> */}
                {/* <Grid item xs={12}>
                    <FileInput
                        defaults={fields.udise_file ? [fields.udise_file] : undefined}
                        title="Disability Certifiacte(if available)"
                        subTitle="Only .pdf less than 1mb are required."
                        accept=".pdf"
                        onChange={(newUrl) => {
                            setFields({ ...fields,err:'', udise_file: newUrl })
                        }} 
                        onDelete={(newList)=>{setFields({ ...fields, udise_file: '' })}}
                        />
                </Grid> */}

                <Grid item xs={12}>
                    <FileInput
                        onDelete={() => { setFields({ ...fields, photo: '' }) }}
                        defaults={fields.photo ? [fields.photo] : undefined}
                        title="Photo Identity"
                        subTitle="Only png, jpg, jpeg are required."
                        onlyImage
                        onChange={(newUrl) => {
                            setFields({ ...fields, err: '', photo: newUrl })
                        }} />
                </Grid>


                {/* <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.father_name}
                        onChange={(e) => setFields({ ...fields, err: '', father_name: e.target.value })}
                        type="text"
                        label={"Father Name"}

                    />
                </Grid>

                <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.father_occupation}
                        onChange={(e) => setFields({ ...fields, err: '', father_occupation: e.target.value })}
                        type="text"
                        label={"Father Occupation"}

                    />
                </Grid>



                <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.mother_name}
                        onChange={(e) => setFields({ ...fields, err: '', mother_name: e.target.value })}
                        type="text"
                        label={"Mother Name"}

                    />
                </Grid>

                <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.mother_occupation}
                        onChange={(e) => setFields({ ...fields, err: '', mother_occupation: e.target.value })}
                        type="text"
                        label={"Mother Occupation"}

                    />
                </Grid>


                <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.family_income}
                        onChange={(e) => setFields({ ...fields, err: '', family_income: e.target.value })}
                        type="number"
                        label={"Family Income (yearly)"}

                    />
                </Grid>

                <Grid item sm={6} xs={12}>
                    <CustomInput

                        disabled={loading}
                        value={fields.family_contact}
                        onChange={(e) => setFields({ ...fields, err: '', family_contact: e.target.value })}
                        type="tel"
                        label={"Guardian contact*"}

                    />
                </Grid>

                <Grid item sm={6} xs={12}>
                <CustomInput
                     
                     disabled={loading}
                     value={fields.before_beneficiary_video}
                     onChange={(e) => setFields({ ...fields, err: '', before_beneficiary_video: e.target.value })}
                     type="text"
                     label={"Pre Video Url 1"}

                 />
                 
                 </Grid>
                 <Grid item sm={6} xs={12}>
                 <CustomInput
                     
                     disabled={loading}
                     value={fields.after_beneficiary_video}
                     onChange={(e) => setFields({ ...fields, err: '', after_beneficiary_video: e.target.value })}
                     type="text"
                     label={"Pre Video Url 2"}

                 />
                 </Grid>
             */}
            </Grid>
        </Box>
    </>
}
export default PersonalDetailsFields